import React from 'react';
import { Typography, Stack, Divider } from '@mui/material';

import { useRole } from '../../hooks/useRole';
import type { BulkRequestProps, UserProps } from '../../models';
import { fDateTime } from '../../utils/formatTime';

interface AssessmentDetailProps {
	assessmentDates: BulkRequestProps['prefAssessmentDates'] | BulkRequestProps['assessmentDates'];
	location: string;
	user?: UserProps;
	dateLineText: string;
}

export const AssessmentDetail = ({ user, assessmentDates, location, dateLineText }: AssessmentDetailProps) => {
	const { isAdmin } = useRole();

	return (
		<Stack spacing={1}>
			{/* only needed in request view page */}
			{isAdmin && user && (
				<Typography>
					<strong>Name:</strong> {user?.firstname} {user?.lastname}
				</Typography>
			)}
			{/* only needed in request view page */}
			{isAdmin && user && (
				<Typography>
					<strong>Company:</strong> {user?.company}
				</Typography>
			)}
			<Typography>
				<strong>Address:</strong> {location}
			</Typography>

			{assessmentDates?.map((date, index) => {
				if (!date) return null;

				return (
					// biome-ignore lint/suspicious/noArrayIndexKey: display only not modify items
					<React.Fragment key={index}>
						<Divider sx={{ my: 2 }} />
						<Typography>
							<strong>
								{index + 1}
								{['st', 'nd', 'rd'][index] ?? 'th'} {dateLineText} Date:
							</strong>{' '}
							{fDateTime(date)}
						</Typography>
					</React.Fragment>
				);
			})}
		</Stack>
	);
};
